import type {
  SearchFilterCondition,
  SearchFilterConditionCustomAttribute,
  SearchFilterField,
  SearchFilterOperator,
  SearchFilters,
} from 'lib-search-types';

import { filterOperatorGroups } from '../../components/filters/utils/definitions';

/**
 * Checks if the given filter node is a leaf filter condition (has field,
 * operator, values).
 */
export function isLeafFilterCondition(
  node: SearchFilterCondition<'conversations'> | SearchFilters<'conversations'>,
): node is SearchFilterCondition<'conversations'> {
  return 'field' in node;
}

/**
 * Checks if the given filter node is a nested filter group (has strategy and
 * filters).
 */
export function isNestedFilterGroup(
  node: SearchFilterCondition<'conversations'> | SearchFilters<'conversations'>,
): node is SearchFilters<'conversations'> {
  return 'strategy' in node && 'filters' in node;
}

/** Checks if the given operator is nullish */
export function isNullishFilterOperator(
  operator: SearchFilterOperator<'conversations'>,
): operator is (typeof filterOperatorGroups.nullish)[number] {
  return filterOperatorGroups.nullish.includes(
    operator as (typeof filterOperatorGroups.nullish)[number],
  );
}

/** Checks if the given condition is a custom attribute condition */
export function isCustomAttributeCondition(
  condition: SearchFilterCondition<'conversations'>,
): condition is
  | SearchFilterConditionCustomAttribute<'conversation_custom_attribute'>
  | SearchFilterConditionCustomAttribute<'contact_custom_attribute'> {
  return isCustomAttributeField(condition.field);
}

/** Checks if the given condition field is a custom attribute field. */
export function isCustomAttributeField(
  field: SearchFilterField<'conversations'>,
): field is 'conversation_custom_attribute' | 'contact_custom_attribute' {
  return (
    field === 'conversation_custom_attribute' ||
    field === 'contact_custom_attribute'
  );
}
